<script>
import axios from "axios";

import i18n from "../i18n";
import { Component, Mixins, Vue } from "vue-property-decorator";
import { AuthModule } from "@/store/modules/auth.module";
import { NotificationsModule } from "@/store/modules/notification.module";
import { settingsComputed } from "@/store/helper";
import { SettingModule } from "@/store/modules/settings.module";
import navBarMachine from "./machines/navBarMachine";
import Loader from "@/components/widgets/loader.vue";

import { constants } from "@/store/constants";

import { interpret } from "xstate";
import simplebar from "simplebar-vue";
import * as signalR from "@microsoft/signalr";
import { bus } from "@/main";

import { VUE_APP_APP_NC_HUB_URL } from "@/services/config";

/**
 * Nav-bar Component
 */
export default {
    data() {
        return {
            languages: [
                {
                    //flag: require("@/assets/images/flags/us.jpg"),
                    language: "en",
                    title: "English",
                },
                {
                    //flag: require("@/assets/images/flags/french.jpg"),
                    language: "fr",
                    title: "French",
                },
                {
                    //flag: require("@/assets/images/flags/spain.jpg"),
                    language: "es",
                    title: "Spanish",
                },
                {
                    //flag: require("@/assets/images/flags/chaina.png"),
                    language: "zh",
                    title: "Chinese",
                },
                {
                    //flag: require("@/assets/images/flags/arabic.png"),
                    language: "ar",
                    title: "Arabic",
                },
            ],
            lan: i18n.locale,
            text: null,
            flag: null,
            value: null,
            fullName: AuthModule.fullName,
            showNotificationcard: false,
            machine: null,
            machineService: null,
            state: null,
            connection: null,
            accessKey: null,
            userId: null,
        };
    },

    components: { simplebar, Loader },
    mounted() {
        this.value = this.languages.find((x) => x.language === i18n.locale);
        this.text = this.value.title;
        this.flag = this.value.flag;
    },
    computed: {
        ...settingsComputed,

        notifications() {
            return NotificationsModule.notificationDetails;
        },

        notificationCount() {
            return NotificationsModule.notificationCount;
        },

        notificationTypes() {
            return constants.NotificationTypes;
        },

        isClient() {
            return SettingModule.userRole == "CLIENT";
        },
    },

    methods: {
        toggleMenu() {
            this.$parent.toggleMenu();
        },
        toggleRightSidebar() {
            this.$parent.toggleRightSidebar();
        },
        initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },
        dashBoard() {
            this.$router.push({ name: "DashBoard" });
        },
        setLanguage(locale, country, flag) {
            this.lan = locale;
            this.text = country;
            this.flag = flag;
            i18n.locale = locale;
        },
        showNotifications() {
            this.showNotificationcard = true;
            this.machineService.send({ type: "NOTIFICATION" });
        },

        UpdateIsSeen(id) {
            NotificationsModule.UpdateIsSeen(id).then((response) => {
                if (response) {
                    this.showNotificationcard = false;
                }
            });
        },
        goToNotification() {
            this.$router.push({ name: "Notification" });
            this.showNotificationcard = false;
        },
        logout() {
            AuthModule.Logout().then((response) => {
                localStorage.clear();
                //this.$router.push("/");
            });
        },
        goToOverView(notification) {
            this.machineService.send({ type: "UPDATE_IS_ACTIVE", notificationId: notification.id });
            this.$router.push({ name: "ViewEntry", params: { entryId: notification.notificationData.entryId } });
        },

        AcceptRequest(notificationId, isAccept) {
            const currentRoute = this.$route.name;

            if (currentRoute === "Notification") {
                bus.$emit("showRequestTrackingModal", {
                    requestTrackingNotificationId: notificationId,
                    isAccept: isAccept,
                });
            } else {
                this.$router.push({ name: "Notification", params: { requestTrackingNotificationId: notificationId, isAccept: isAccept } });
            }
        },
    },

    created() {
        // await this.initializeSignalR();
        this.machine = navBarMachine;
        this.machineService = interpret(this.machine, { devTools: true });
        this.state = this.machine.initialState;
        this.machineService.start();
        this.machineService.onTransition((state) => {
            var previousState = this.state;
            this.state = state;
        });
    },
    destroyed() {
        this.machineService.stop();
    },
};
</script>

<template>
    <header id="page-topbar">
        <div class="navbar-header">
            <div class="qn-d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box">
                    <a href="javascript:void(0)" @click="dashBoard" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="@/assets/images/logo.svg" alt height="22" />
                        </span>
                        <span class="logo-lg">
                            <!-- <img src="@/assets/images/logo-dark.png" alt height="17" /> -->
                        </span>
                    </a>

                    <a href="javascript:void(0)" @click="dashBoard" class="logo logo-light">
                        <span class="logo-sm">
                            <!-- <img src="@/assets/images/logo-icon.svg" alt height="30" /> -->
                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5.78411 0.0322266C2.60011 0.0322266 0.0161133 2.61356 0.0161133 5.80023V31.0029H5.44278V4.58423H17.7521C20.7601 4.58423 23.0774 5.34156 24.7094 6.85889C26.3414 8.37623 27.1574 10.4856 27.1574 13.1869C27.1574 15.8882 26.3414 18.0029 24.7094 19.5336C23.0774 21.0616 20.7601 21.8269 17.7521 21.8269H11.3681V31.0056H18.7068C25.4881 31.0056 30.9868 25.5069 30.9868 18.7256V0.0322266H5.78411Z"
                                    fill="#AFD580"
                                />
                                <path d="M21.4588 13.184C21.4588 10.5333 19.8908 9.20801 16.7575 9.20801H11.3682V17.2347H16.7575C19.8935 17.2373 21.4588 15.8853 21.4588 13.184Z" fill="#AFD580" />
                                <path
                                    d="M11.3682 30.6643V30.9977C12.6002 30.9977 13.8348 30.9977 15.0668 30.9977C15.1282 30.9977 15.1895 30.987 15.2482 30.9763C15.5228 30.9203 15.7948 30.859 16.0695 30.8083C16.8962 30.659 17.7202 30.5017 18.5468 30.3657C19.2775 30.2457 20.0108 30.147 20.7442 30.051C21.2615 29.9843 21.7788 29.931 22.2988 29.8803C22.8828 29.8243 23.4668 29.779 24.0508 29.7257C24.1148 29.7203 24.1788 29.7043 24.2348 29.675C25.2215 29.179 26.1202 28.5603 26.9388 27.8217C26.9602 27.803 26.9762 27.779 26.9948 27.7603C26.9922 27.7523 26.9868 27.7443 26.9842 27.7363C21.6508 28.0457 16.4322 28.955 11.3682 30.6643Z"
                                    fill="#43B676"
                                />
                                <path
                                    d="M29.7146 23.6185C28.8346 23.6639 27.9546 23.7279 27.0772 23.8292C26.2746 23.9199 25.4719 24.0212 24.6692 24.1279C23.6106 24.2692 22.5572 24.4585 21.5092 24.6665C19.7999 25.0052 18.1039 25.4159 16.4292 25.9039C14.7092 26.4052 13.0186 26.9919 11.3652 27.6799V28.9225C13.3839 28.1759 15.4452 27.5625 17.5412 27.0532C19.6026 26.5519 21.6826 26.1599 23.7839 25.8745C24.7706 25.7385 25.7626 25.6239 26.7546 25.5412C27.4772 25.4825 28.1999 25.4399 28.9226 25.3945C28.9919 25.3892 29.0319 25.3652 29.0692 25.3092C29.3946 24.7972 29.6852 24.2665 29.9306 23.7119C29.9439 23.6825 29.9546 23.6479 29.9706 23.6025C29.8826 23.6079 29.7972 23.6159 29.7146 23.6185Z"
                                    fill="#43B676"
                                />
                                <path
                                    d="M5.4426 30.8447C5.38393 30.8847 5.32527 30.9247 5.2666 30.9647C5.26927 30.9727 5.27193 30.9834 5.2746 30.9914C5.2986 30.9941 5.32527 30.9967 5.34927 30.9967C5.3786 30.9967 5.4106 30.9967 5.43993 30.9967V30.8447H5.4426Z"
                                    fill="#43B676"
                                />
                                <path
                                    d="M5.44272 27.2803C3.68805 26.6856 1.90672 26.1896 0.0987166 25.779C0.0693832 25.7736 0.0400499 25.771 0.00804992 25.7656C0.00804992 26.1896 0.00804992 26.6003 0.00804992 27.019C1.48005 27.419 2.93072 27.867 4.36805 28.4136C4.35738 28.4323 4.33605 28.4376 4.32272 28.4483C3.84272 28.8376 3.36272 29.227 2.88538 29.619C2.82405 29.6696 2.77338 29.675 2.69872 29.6536C1.96805 29.4483 1.23738 29.2456 0.506717 29.043C0.34405 28.9976 0.181383 28.9603 0.0187166 28.9176C-0.00795009 29.035 -0.00528341 30.899 0.0213833 30.9896C0.0373833 30.9923 0.0587166 30.995 0.0773833 30.995C0.866717 30.995 1.65872 30.995 2.44805 30.9976C2.50672 30.9976 2.54938 30.9763 2.59205 30.939C3.49072 30.1816 4.44805 29.5096 5.44272 28.8883V27.2803Z"
                                    fill="#43B676"
                                />
                                <path
                                    d="M0.0107422 22.1416C0.0107422 22.6989 0.0107422 23.2376 0.0107422 23.7656C0.920075 24.0269 1.82408 24.2803 2.72274 24.5496C3.61874 24.8163 4.50408 25.1203 5.38141 25.4403C5.40008 25.4483 5.42141 25.4563 5.44008 25.4616V24.0829C3.86674 23.4269 2.26674 22.8456 0.637409 22.3363C0.437409 22.2696 0.232076 22.2083 0.0107422 22.1416Z"
                                    fill="#43B676"
                                />
                                <path d="M21.4588 13.184C21.4588 10.5333 19.8908 9.20801 16.7575 9.20801H11.3682V17.2347H16.7575C19.8935 17.2373 21.4588 15.8853 21.4588 13.184Z" fill="#43B676" />
                                <path
                                    d="M31 0.210667C31 0.173333 31 0.133333 31 0.096C31 0.0666667 30.9946 0.0373333 30.9893 0C30.9333 0 30.8826 0 30.8346 0C29.504 0 28.1733 0 26.8426 0C19.552 0 12.2586 0 4.96798 0C4.58665 0 4.21065 0.0293334 3.83732 0.112C1.59465 0.605333 0.0053167 2.57333 0.00265003 4.86667C-1.66374e-05 9.952 0.00265003 15.04 0.00265003 20.1253C0.00265003 20.168 0.00265003 20.208 0.00265003 20.2533C0.159983 20.3067 0.309317 20.3547 0.45865 20.4053C2.14932 20.9813 3.80798 21.6267 5.44265 22.3333L5.44278 4.58423H17.7521C20.7601 4.58423 23.0774 5.34156 24.7094 6.85889C26.3414 8.37623 27.1574 10.4856 27.1574 13.1869C27.1574 15.8882 26.3414 18.0029 24.7094 19.5336C23.0774 21.0616 20.7601 21.8269 17.7521 21.8269H11.3681L11.368 25.8533C14.28 24.6213 17.2773 23.6427 20.344 22.8667C22.192 22.4 24.0533 22.008 25.9387 21.712C26.7866 21.5787 27.6373 21.4613 28.488 21.3547C29.1333 21.2747 29.784 21.224 30.432 21.1573C30.5386 21.1467 30.6453 21.1387 30.752 21.128C30.76 21.1093 30.7653 21.096 30.768 21.08C30.7733 21.0587 30.7786 21.0347 30.784 21.0133C30.9333 20.2187 31 19.4187 31 18.6107C31 12.4773 31 6.344 31 0.210667Z"
                                    fill="#43B676"
                                />
                                <path
                                    d="M31.0027 12.0931H21.6374C21.1333 10.3331 19.504 9.03711 17.5893 9.03711H10.832V10.9411H7.93335V11.5544H10.832V15.3544H7.93335V15.9678H10.832V17.4558H17.5893C19.5067 17.4558 21.1333 16.1598 21.6374 14.3998H31V12.0931H31.0027Z"
                                    fill="#333E48"
                                />
                            </svg>
                        </span>
                        <span class="logo-lg gray-900">
                            <img src="@/assets/images/logo-light.svg" alt height="36" />
                        </span>
                    </a>
                </div>
            </div>

            <div class="qn-d-flex flex-fill navbar-right">
                <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item" @click="toggleMenu">
                    <i class="fa fa-fw fa-bars"></i>
                </button>

                <!-- Tenant Name -->
                <!-- <div class="d-v-center d-none d-sm-flex">
					<h5 class="m-0 tenant-name d-v-center">
						<span class="text-secondary fs-6 me-2">Tenant:</span>
						<span>{{ tenant.name }}</span>
					</h5>
				</div> -->
                <div class="qn-d-flex flex-fill justify-content-end">
                    <div class="dropdown d-none d-lg-inline-block ms-2">
                        <button type="button" class="btn header-item noti-icon" @click="initFullScreen">
                            <i class="bx bx-fullscreen"></i>
                        </button>
                    </div>

                    <b-dropdown menu-class="dropdown-menu-lg p-0 dropdown-menu-end" toggle-class="header-item noti-icon" variant="black" v-if="!isClient">
                        <template v-slot:button-content>
                            <a href="javascrpit:void(0)" @click="showNotifications">
                                <i class="bx bx-bell" :class="{ 'bx-tada': notificationCount > 0 }"></i>
                                <span class="badge bg-danger rounded-pill bell-icon" v-if="notificationCount > 0">{{ notificationCount }}</span>
                            </a>
                        </template>
                        <div v-if="showNotificationcard == true" @click="goToNotification">
                            <div class="p-3 border-bottom">
                                <h6 class="mb-0 fs-16">Notifications</h6>
                            </div>
                            <Loader :loading="state.matches('gettingNotifications')">
                                <div v-if="notifications.length > 0">
                                    <!-- <div v-if="showNotificatio2ncard"> -->
                                    <simplebar style="max-height: 535px">
                                        <div
                                            v-for="notification in notifications"
                                            :class="{ 'cursor-pointer': notification.typeId != notificationTypes.EntryDeleteNotificationId() }"
                                            :key="notification"
                                            class="nav-notification-list"
                                            @click.stop="goToOverView(notification)"
                                        >
                                            <div class="d-v-center">
                                                <div class="me-3 header-profile-user ">
                                                    <img :src="notification.notificationData.profileImageUrl" class="rounded-circle" />
                                                </div>
                                                <div class="notification-para">
                                                    <span class="gray-600">{{ notification.notificationData.notificationMessage }}</span>
                                                </div>
                                            </div>
                                            <div class="ms-5 d-flex-between">
                                                <p class="notification-time-format me-3 mb-0">
                                                    <span class="align-middle gray-500">{{ notification.formattedTime() }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </simplebar>
                                </div>
                                <div class="text-center notification-bell-icon" v-else>
                                    <div class="d-center">
                                        <i class="bx bx-bell-off"></i>
                                    </div>
                                    <h6 class="fw-600 fs-16">
                                        No new notifications found.
                                    </h6>
                                    <p class="mb-3">
                                        We'll notify you when something new arrives.
                                    </p>
                                    <button class="btn btn-sm btn-primary mb-0" @click="goToNotification">Notification Center</button>
                                </div>
                            </Loader>

                            <!-- </div> -->
                            <div class="p-2 border-top qn-d-flex mt-2" v-if="notifications.length > 0">
                                <a class="btn btn-sm btn-primary text-start" href="javascript:void(0)">
                                    <span key="t-view-more" class="me-2 fs-12"> View All</span>
                                    <i class="mdi mdi-arrow-right text-white me-1"></i>
                                </a>
                            </div>
                        </div>
                    </b-dropdown>

                    <!-- User account -->

                    <b-dropdown right variant="black" menu-class="dropdown-menu-end btn-avatar" toggle-class="header-item">
                        <template v-slot:button-content>
                            <span class="d-v-center">
                                <span class="header-profile-user ms-2">
                                    <img :src="userProfile.profileImageUrl" />
                                </span>
                                <span class="d-none d-xl-inline-block ms-1">
                                    {{ fullName }}
                                </span>
                                <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                            </span>
                        </template>
                        <b-dropdown-item>
                            <router-link to="/profile" class="gray-600 navbar-user-profile">
                                <i class="bx bx-user  align-middle me-1"></i>
                                Profile
                            </router-link>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <a href="javascript:void(0)" @click="logout" class="gray-600 navbar-user-profile">
                                <i class="bx bx-power-off  align-middle me-1 text-danger"></i>
                                {{ $t("navbar.dropdown.henry.list.logout") }}
                            </a>
                        </b-dropdown-item>

                        <!-- <router-link to="/profile" class="dropdown-item">
                            <i class="bx bx-user  align-middle me-1"></i>
                            Profile
                        </router-link>
                        <b-dropdown-divider></b-dropdown-divider>
                        <a href="javascript:void(0)" @click="logout" class="dropdown-item text-danger">
                            <i class="bx bx-power-off  align-middle me-1 text-danger"></i>
                            {{ $t("navbar.dropdown.henry.list.logout") }}
                        </a> -->
                    </b-dropdown>

                    <!-- <div class="dropdown d-inline-block">
					<button type="button" class="btn header-item noti-icon right-bar-toggle toggle-right" @click="toggleRightSidebar">
						<i class="bx bx-cog bx-spin toggle-right"></i>
					</button>
				</div> -->
                </div>
            </div>
        </div>
    </header>
</template>

<style scoped>
.navbar-user-profile {
    padding: 0.25rem 0.5rem;
}

.logo-lg {
    font-weight: 500;
    font-size: 1.75rem;
    color: #fff;
}
</style>
